import { Component, computed, input, InputSignal, OnInit, signal, Signal, OnDestroy } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastService } from '@services/helper/toast.service';
import { CustomModalComponent } from '@components/misc/custom-modal/custom-modal.component';
import { AwButtonComponent } from '@components/misc/aw-button/aw-button.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HelperService } from '@services/helper/helper.service';
import { fees } from './fees';
import { MixpanelService } from '@services/mixpanel/mixpanel.service';

@Component({
    selector: 'app-instant-payout-modal',
    imports: [CustomModalComponent, TranslateModule, AwButtonComponent, FormsModule, ReactiveFormsModule],
    templateUrl: './instant-payout-modal.component.html',
    styleUrl: './instant-payout-modal.component.scss'
})
export class InstantPayoutModalComponent implements OnInit, OnDestroy {
    payoutFee: string;
    loading: boolean;
    hasConfirmed = false;
    payoutAmount: InputSignal<number> = input(0);
    currency: InputSignal<string> = input('');
    payoutAmountFormatted: Signal<string> = computed(() => {
        return this.helperService.localizeNumberWithCurrency(this.payoutAmount() / 100, 2, 2, this.currency());
    });
    payoutResult: Signal<string> = computed(() => {
        const fee = fees[this.currency()] * 100;
        const forPayout = (this.payoutAmount() - fee) / 100;
        return this.helperService.localizeNumberWithCurrency(forPayout, 2, 2, this.currency());
    });
    negativePayout: Signal<boolean> = computed(() => {
        return this.payoutAmount() - fees[this.currency()] * 100 < 0;
    });

    constructor(
        protected modalService: NgbModal,
        private toastService: ToastService,
        protected helperService: HelperService,
        private translate: TranslateService,
        private mixpanelService: MixpanelService
    ) {}

    async ngOnInit() {
        this.payoutFee = this.helperService.localizeNumberWithCurrency(fees[this.currency()], 2, 2, this.currency());

        console.log('values', {
            payoutCurrency: this.currency(),
            payoutAmount: this.payoutAmount(),
            payoutFee: this.payoutFee,
            payoutResult: this.payoutResult()
        });
        // 🔹 Track modal opened
        this.mixpanelService.track('Instant Payout: Modal Opened', {
            payoutAmount: this.payoutAmount(),
            payoutFee: this.payoutFee,
            payoutResult: this.payoutResult()
        });
    }

    ngOnDestroy() {
        // 🔹 If closed without confirming, track abandonment
        if (!this.hasConfirmed) {
            this.mixpanelService.track('Instant Payout: Modal Closed Without Confirm', {
                payoutAmount: this.payoutAmount(),
                payoutFee: this.payoutFee,
                payoutResult: this.payoutResult()
            });
        }
    }

    confirmInstantPayout() {
        this.loading = true;
        this.hasConfirmed = true;

        // 🔹 Track confirm click
        this.mixpanelService.track('Instant Payout: Confirm Clicked', {
            payoutAmount: this.payoutAmountFormatted(),
            payoutFee: this.payoutFee,
            payoutResult: this.payoutResult()
        });
        const randomMs = (min = 500, max = 1500): number => Math.floor(Math.random() * (max - min + 1)) + min;
        setTimeout(() => {
            this.toastService.info(this.translate.instant('overview.instant_payout_currently_unavailable'));
            this.loading = false;
        }, randomMs());
    }
}
